import layout from '../layout'
export default function makeVideoRoutes({
  contentType,
  components: { VideoListingContainer }
}) {

  return [
    {
      path: '/',
      component: layout,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: `/${contentType.name}/list/:categoryId`,
          component: VideoListingContainer,
          props: {
            contentType,
          }
        },
      ]
    },
  ];
}
